import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=c11b4718&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=c11b4718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11b4718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c11b4718')) {
      api.createRecord('c11b4718', component.options)
    } else {
      api.reload('c11b4718', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=c11b4718&scoped=true&", function () {
      api.rerender('c11b4718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26MWb6Cu2sH5d/JS/comp/CookieBox.vue"
export default component.exports